export default __webpack_public_path__ + "static/media/postman-logo-F43375A2EB-seeklogo.com.89372524.png";